import { useTranslation } from "react-i18next";
import { marqueeItems } from "@/mocks/siteData";

export default function MarqueeStrip() {
  const { t } = useTranslation();
  const items = [...marqueeItems, ...marqueeItems];

  return (
    <div className="bg-primary-500 overflow-hidden py-4">
      <div className="marquee-track animate-marquee gap-10">
        {items.map((item, index) => (
          <div key={`${item.key}-${index}`} className="flex items-center gap-3 shrink-0">
            <span className="w-8 h-8 rounded-full bg-background-50/15 text-background-50 flex items-center justify-center">
              <i className={`${item.icon} text-base w-5 h-5 flex items-center justify-center`} />
            </span>
            <span className="font-heading font-semibold uppercase tracking-wide text-xs md:text-sm text-background-50 whitespace-nowrap">
              {t(item.key)}
            </span>
            <i className="ri-star-fill text-background-50/50 text-[8px] w-3 h-3 flex items-center justify-center" />
          </div>
        ))}
      </div>
    </div>
  );
}